{
  "user": {
    "email": {
      "label": "Email address",
      "validations": {
        "required": "Email address is required",
        "valid": "Invalid email address"
      }
    },
    "password": {
      "label": "Password",
      "validations": {},
      "field": {
        "show": "Show password",
        "hide": "Hide password"
      }
    },
    "confirm_password": {
      "label": "Confirm Password",
      "validations": {}
    },
    "firstName": {
      "label": "First name",
      "validations": {
        "required": "Enter your first name"
      }
    },
    "middleName": {
      "label": "Middle name",
      "validations": {}
    },
    "lastName": {
      "label": "Last name",
      "validations": {
        "required": "Enter your last name"
      }
    },
    "phoneCountryCode": {
      "label": "Phone country",
      "place_holder": "Phone country",
      "validations": {}
    },
    "phoneNationalNumber": {
      "label": "Phone number",
      "place_holder": "Phone number",
      "validations": {}
    },
    "language": {
      "label": "Language",
      "place_holder": "Select a language..",
      "validations": {}
    }
  },
  "organization": {
    "name": {
      "label": "Name",
      "validations": {
        "required": "Enter the organization name"
      }
    },
    "create": "Create Organization",
    "select": "Select Organization",
    "companyName": {
      "label": "Company",
      "validations": {
        "required": "Enter the company name"
      }
    },
    "email": {
      "label": "Email",
      "validations": {
        "required": "Enter the organization email",
        "valid": "Enter a valid email"
      }
    },
    "vatNumber": {
      "label": "VAT",
      "validations": {
        "required": "VAT number is required",
        "valid": "Invalid VAT number"
      }
    },
    "language": {
      "label": "Language",
      "validations": {
        "required": "Language is required"
      }
    }
  },
  "department": {
    "label": "Department",
    "overlay_title": "New Department",
    "create": "Create Department",
    "name": {
      "label": "Department Name",
      "validations": {
        "empty": "Name is required",
        "duplicate_name": "Department with this name already exists",
        "min_length": "Min length of name is {{minLength}} characters",
        "max_length": "Max length of name is {{maxLength}} characters",
        "invalid": "Name should begin with a letter and end with a letter or digit. May include spaces, dots and dashes."
      }
    },
    "organization": {
      "label": "Organization",
      "validations": {
        "empty": "Organization is required"
      }
    },
    "description": {
      "label": "Description",
      "validations": {
        "empty": "Description is required",
        "max_length": "Max length of description is 200 characters"
      }
    },
    "thumbnail": {
      "label": "Thumbnail",
      "validations": {
        "empty": "Thumbnail is required"
      }
    }
  },
  "project": {
    "label": "Project",
    "create": "Create Project",
    "not_allowed": "You do not have permissions to create projects within this organization",
    "departmentId": {
      "label": "Department",
      "place_holder": "",
      "validations": {
        "required": "Department is required"
      }
    },
    "name": {
      "label": "Name",
      "place_holder": "",
      "validations": {
        "required": "Name is required"
      }
    }
  },
  "cluster": {
    "label": "Cluster",
    "name": {
      "label": "Name"
    },
    "create": "Create Cluster",
    "create_service": "Create service",
    "not_allowed": "You do not have permissions to create services within this project",
    "description": {
      "label": "Description",
      "not_set": "No description set"
    },
    "replicas": {
      "label": "Replicas"
    },
    "allowed_source_ranges": {
      "label": "Allowed source ranges",
      "validations": {
        "invalid": "Invalid IPv4 with subnet mask"
      },
      "network_mask_hint": "This is the multi-value field. Please, press enter to submit the value."
    },
    "k8s_status": {
      "label": "Status",
      "values": {
        "unavailable": "UNAVAILABLE",
        "running": "RUNNING",
        "creating": "CREATING",
        "updating": "UPDATING",
        "error": "ERROR",
        "importing": "IMPORTING",
        "starting": "STARTING",
        "stopping": "STOPPING",
        "stopped": "STOPPED"
      }
    },
    "patroni_status": {
      "label": "Patroni status",
      "values": {
        "running": "Running",
        "updating": "Updating",
        "pending": "Pending"
      }
    },
    "connection_details": {
      "label": "Connection details",
      "string": "Connection string",
      "read_only": {
        "label": "Read-only"
      },
      "username": {
        "label": "Username"
      },
      "password": {
        "label": "Password"
      }
    },
    "application_connection_details": {
      "label": "Application connection credentials"
    }
  },
  "backups": {
    "logical": {
      "status": {
        "logical_backup_completed": "Logical backup completed",
        "logical_backup_failed": "Logical backup failed"
      }
    }
  },
  "dataset": {
    "status": {
      "values": {
        "importing": "Import started",
        "successful": "Import finished",
        "failure": "Import failed",
        "aborted": "Import aborted"
      },
      "secondary_text": "{{cluster}}"
    }
  },
  "address": {
    "line1": {
      "label": "Address 1",
      "place_holder": "",
      "validations": {
        "required": "Address line 1 is required"
      }
    },
    "line2": {
      "label": "Address 2",
      "place_holder": "",
      "validations": {}
    },
    "line3": {
      "label": "Address 3",
      "place_holder": "",
      "validations": {}
    },
    "postalCode": {
      "label": "Zip / Postal Code",
      "place_holder": "",
      "validations": {
        "required": "Postal code is required"
      }
    },
    "city": {
      "label": "City",
      "place_holder": "",
      "validations": {
        "required": "City is required"
      }
    },
    "state": {
      "label": "State",
      "place_holder": "",
      "validations": {}
    },
    "countryCode": {
      "label": "Country",
      "place_holder": "Select a country..",
      "validations": {
        "required": "Country is required"
      }
    }
  },
  "compute_plan": {
    "label": "Compute plan",
    "cpu": {
      "label": "Cores"
    },
    "memory": {
      "label": "Memory"
    }
  },
  "storage_plan": {
    "label": "Storage plan",
    "type": {
      "label": "Type"
    },
    "size": {
      "label": "Size"
    }
  },
  "languages": {
    "en": {
      "name": "English"
    },
    "de": {
      "name": "German"
    },
    "es": {
      "name": "Spanish"
    }
  },
  "countries": {
    "AT": {
      "name": "Austria"
    },
    "CH": {
      "name": "Switzerland"
    },
    "DE": {
      "name": "Germany"
    }
  },
  "roles": {
    "owner": "Owner",
    "member": "Member",
    "biller": "Biller"
  }
}
